import React from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Space } from "antd";

import { Page } from "../../components/page";
import { sendRequest } from "../../store/contact/actions";
import { ContactPayload } from "../../store/contact/types";
import { RootState } from "../../store/root_reducer";

const { TextArea } = Input;

export const ContactPage: React.FC = () => {
  const { t } = useTranslation(["contact_page"]);

  const [form] = Form.useForm();

  const selectedGate = useSelector((state: RootState) => state.User.selectedGate);

  const dispatch = useDispatch();

  const onFinish = (message: ContactPayload) => {
    dispatch(
      sendRequest({
        ...message,
        gateId: selectedGate.id,
      })
    );
    form.resetFields();
  };

  return (
    <Page title={t("title")} description={t("description")}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Form name="basic" initialValues={{ remember: true }} onFinish={onFinish} form={form}>
          <Form.Item name="message" rules={[{ required: true, message: t("form.messageValidationError") }]}>
            <TextArea rows={6} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t("form.sendButton")}
            </Button>
          </Form.Item>
        </Form>
      </Space>
    </Page>
  );
};
